import { BydReportInterface } from '../interfaces/byd-report.interface';
import { BydReportFile } from './byd-report-file.model';

export class BydReport implements BydReportInterface {
  /**
   * Id.
   */
  public id: number;

  /**
   * Template name.
   */
  public reportName: string;

  /**
   * Files.
   */
  public files: BydReportFile[] = [];

  /**
   *
   */
  public jobId: number;

  /**
   * State.
   */
  public state: string;

  /**
   * Job name.
   */
  public jobName: string;

  /**
   * Creator first name.
   */
  public creatorFirstName: string;

  /**
   * Creator last name.
   */
  public creatorLastName: string;

  /**
   * Creation date.
   */
  public creationDate: number;

  /**
   * Template name.
   */
  public templateName?: string;

  /**
   * Model family.
   */
  public modelFamily?: string;

  /**
   * Debug stacktrace.
   */
  public stacktrace: [];

  /**
   * PinTemplate constructor.
   *
   * @param jsonData Pin Template data.
   */
  constructor(jsonData) {
    if (jsonData) {
      this.id = jsonData.id;
      this.reportName = jsonData.reportName;
      jsonData.returnvalue?.files?.forEach((file) => {
        if (file) this.files.push(new BydReportFile(file));
      });
      this.jobId = jsonData.jobId;
      this.state = jsonData.state;
      this.jobName =
        jsonData.jobName === 'BimDataCustomExport.PROCESS' ? this.getJobName(jsonData.data) : jsonData.jobName;
      this.creatorFirstName = jsonData.data?.userInfo.firstName;
      this.creatorLastName = jsonData.data?.userInfo.lastName;
      this.creationDate = jsonData.timestamp;
      this.templateName = jsonData.data?.modelInfo?.fileName;
      if (jsonData.data?.modelInfo?.type) this.modelFamily = jsonData.data?.modelInfo?.type;
      if (jsonData.stacktrace?.length) this.stacktrace = jsonData.stacktrace;
    }
  }

  /**
   * @param data Data.
   * @returns String - report ext
   */
  public getJobName(data): string {
    const { modelInfo, filter } = data;
    switch (modelInfo.ext) {
      case 'xlsx':
        return 'xlsx';
      case 'docx':
        if (filter.docxToPdf) {
          return 'pdf';
        } else {
          return 'docx';
        }
      default:
        return 'no_ext';
    }
  }
}
